module.exports = "/images/doos.png?fab70aa97f66d9ff0cfb747a63d8f88f";